export class AddFoodLogInputModel {
  constructor(
    public date: number,
    public amount: number,
    public food: string,
    public meal: string,
    public unit: string,
    public user: string,
    public mealId?: string
  ) {}
}

export class AddQuikFoodLog {
  constructor(
    public date: number,
    public amount: number,
    public calorie: number,
    public title: string,
    public meal: string,
    public foods: [],
    public user: string
  ) {}
}
